class Flux360LoadingScreen {
    
    constructor(context) {
        this.loadingscreen = document.getElementById("Flux360LoadingScreenVue");
        // this.loadingscreenText = document.getElementsByClassName("lsVUE-text")[0];
        this.context = context;
    }

    displayLoadingUI() {
        this.context.setLoadingscreenVisible(true);
    }

    hideLoadingUI() {
        // if panoramavideo inside situation -> Loadingscreen will be disabled inside VideoSphere.js when video meta data is loaded
        if(!this.context.isVideoPanorama)
            this.context.setLoadingscreenVisible(false);
    }

    setLoadingUIText(text) {
        // this.loadingscreenText.innerHTML = text;    
        // this.loadingscreenText.style.opacity = 1;
    }
}

export { Flux360LoadingScreen };
export default Flux360LoadingScreen;